import React from "react";
import Preloader from "../../../../../common-deprecated/styles/v2/toyota/custom/Preloader";
import * as Styles from "./styles/Valuation";
import { useTradeInAemLabel } from "../../../../utils/labels";

const ValuationLoadingContainer = (): JSX.Element => {
    const loadingLabel = useTradeInAemLabel("tradeInAemLoading");
    return (
        <Styles.ValuationLoading>
            <Preloader />
            <Styles.LoaderText>{loadingLabel}</Styles.LoaderText>
        </Styles.ValuationLoading>
    );
};
export default ValuationLoadingContainer;
